module.exports = __webpack_public_path__ + "img/redEnvelopedRainResultImage.397cad06.png";